import { useState } from 'react';
import { useMonitorStore } from '../lib/monitorStore';

interface DecryptModalProps {
  sessionId: string;
  onClose: () => void;
}

export function DecryptModal({ sessionId, onClose }: DecryptModalProps) {
  const { decryptionKeys, setDecryptionKey, clearDecryptionKey } = useMonitorStore();
  const existingKey = decryptionKeys.get(sessionId) || '';
  const [key, setKey] = useState(existingKey);
  const [error, setError] = useState<string | null>(null);

  const validateHexKey = (hex: string): boolean => {
    // net_key is 32 bytes = 64 hex chars
    return /^[a-fA-F0-9]{64}$/.test(hex.trim());
  };

  const handleSave = () => {
    const trimmedKey = key.trim();

    if (!trimmedKey) {
      clearDecryptionKey(sessionId);
      onClose();
      return;
    }

    if (!validateHexKey(trimmedKey)) {
      setError('Invalid key format. Expected 64 hex characters (32 bytes).');
      return;
    }

    setDecryptionKey(sessionId, trimmedKey.toLowerCase());
    onClose();
  };

  const handleClear = () => {
    clearDecryptionKey(sessionId);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Configure Decryption Key</h2>
        <p>
          Enter the net_key for this session to enable client-side packet decryption.
          The key is stored only in your browser and never sent to the server.
        </p>

        <input
          type="text"
          placeholder="64-character hex string (net_key)"
          value={key}
          onChange={(e) => {
            setKey(e.target.value);
            setError(null);
          }}
          autoFocus
        />

        {error && (
          <div style={{ color: '#f85149', fontSize: 13, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <div className="modal-buttons">
          {existingKey && (
            <button className="secondary" onClick={handleClear}>
              Clear Key
            </button>
          )}
          <button className="secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="primary" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
